var map = {
	"./Connect.vue": [
		"b5f5",
		"view-Connect-vue"
	],
	"./InitLoadingHistory.vue": [
		"734f",
		"view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue",
		"view-InitLoadingHistory-vue"
	],
	"./InitLoadingMain.vue": [
		"7c80",
		"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue",
		"view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue",
		"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue",
		"view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue",
		"view-InitLoadingMain-vue"
	],
	"./Login.vue": [
		"2ab8",
		"view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue",
		"view-Login-vue"
	],
	"./Main.vue": [
		"2c48",
		"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue",
		"view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue",
		"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue",
		"view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue",
		"view-Main-vue"
	],
	"./Mypage.vue": [
		"aba3",
		"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue",
		"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue",
		"view-Mypage-vue"
	],
	"./NotFound.vue": [
		"f79b",
		"view-NotFound-vue"
	],
	"./Staking.vue": [
		"c7e7",
		"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue",
		"view-Staking-vue~view-Trading-vue",
		"view-Staking-vue"
	],
	"./TradeHistory.vue": [
		"684e",
		"view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue",
		"view-TradeHistory-vue"
	],
	"./Trading.vue": [
		"9708",
		"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue",
		"view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue",
		"view-Staking-vue~view-Trading-vue",
		"view-Trading-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5dd3";
module.exports = webpackAsyncContext;